import axios from "axios";

function resolveBackendUrl() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (typeof window === "undefined") return envUrl;
  const origin = window.location.origin;
  if (!envUrl) return origin;
  try {
    const envHost = new URL(envUrl).host;
    const isLocal = /localhost|127\.0\.0\.1/.test(window.location.host);
    // Custom domain (e.g. corexebest.com): call same-origin /api to avoid cross-origin/CORS failures
    if (!isLocal && envHost !== window.location.host) return origin;
  } catch (e) { /* fall through */ }
  return envUrl;
}

export const BACKEND_URL = resolveBackendUrl();
export const TOKEN_KEY = "corexe_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "Bir hata oluştu. Tekrar deneyin.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export function resolveImg(url) {
  if (!url) return "";
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtMoney(v, cur = "₺") {
  return `${Number(v || 0).toLocaleString("tr-TR")} ${cur}`;
}
